import React, { useState } from "react";

function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });
  

//   const encode = (data) => {
//     return Object.keys(data)
//       .map(
//         (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
//       )
//       .join("&");
//   };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
//     console.log(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

//     fetch("/", {
//       method: "POST",
//       headers: { "Content-Type": "application/x-www-form-urlencoded" },
//       body: encode({ "form-name": "contact", form }),
//     })
//       .then(() => alert("Message sent!"))
//       .catch((error) => alert(error));

  const emailReceiver = "riki.whyudi45@gmail.com";
  const subject = "Hello Riki Wahyudi";
  const msg = `Hello, \nMy name is ${form.name} \n\n${form.message} \n\n\n`;

  if (
    form.name !== "" &&
    form.email !== "" &&
    form.message !== ""
  ) {
    const a = document.createElement("a");
    a.href = `mailto: ${emailReceiver}?subject=${subject}&body=${encodeURIComponent(msg)}`;
    a.click();
  } else {
    alert("Please fill in all forms.");
  }
     
  };

  return (
    <section id="contact" className="relative">
      <div className="container px-5 py-10 mx-auto flex sm:flex-nowrap flex-wrap">
        <div className="lg:w-2/3 md:w-1/2 bg-gray-900 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
          <iframe
            width="100%"
            height="100%"
            title="map"
            className="absolute inset-0"
            frameBorder={0}
            marginHeight={0}
            marginWidth={0}
            style={{ filter: "opacity(0.7)" }}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3222.1420120334915!2d106.73258197391746!3d-6.3013587936878075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f1202c227c7f%3A0x55b285547291a43f!2sDumbWays%20Indonesia%20(Bintaro)!5e1!3m2!1sid!2sus!4v1683043655686!5m2!1sid!2sus"
//             src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1611.889898080097!2d106.03621588822185!3d-6.0318845179997025!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e418e5dcfae24dd%3A0x5533b7d10f2bd467!2zNsKwMDEnNTMuOCJTIDEwNsKwMDInMTcuMyJF!5e1!3m2!1sid!2sus!4v1673774523675!5m2!1sid!2sus"
          />
          <div className="bg-gray-900 relative flex flex-wrap py-6 rounded shadow-md">
            <div className="lg:w-1/2 px-6">
              <h2 className="title-font font-semibold text-white tracking-widest text-xs">
                ADDRESS
              </h2>
           <p className="mt-1">
                Jl. Elang IV, Sawah Lama. <br />
                Tangerang Selatan, 15413 </p>
            </div>
            <div className="lg:w-1/2 px-6 mt-4 lg:mt-0">
              <h2 className="title-font font-semibold text-white tracking-widest text-xs">
                EMAIL
              </h2>
              <a className="text-indigo-400 leading-relaxed">
                riki.whyudi45@gmail.com
              </a>
              <h2 className="title-font font-semibold text-white tracking-widest text-xs mt-4">
                PHONE
              </h2>
              <p className="leading-relaxed">+6285159666245</p>
            </div>
          </div>
        </div>
        <form
          netlify
          onSubmit={handleSubmit}
          name="contact"
          className="lg:w-1/3 md:w-1/2 flex flex-col md:ml-auto w-full md:py-8 mt-8:mt-0"
        >
          <h2 className="text-white sm:text-4xl text-3xl mb-1 font-medium title-font">
            Hire Me
          </h2>
          <p className="leading-relaxed mb-5">
            I hope to work in your company as soon as possible.!
          </p>
          <div className="relative mb-4">
            <label htmlFor="name" className="leading-7 text-sm text-gray-400">
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              onChange={handleChange}
              className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
          <div className="relative mb-4">
            <label htmlFor="email" className="leading-7 text-sm text-gray-400">
              Email
            </label>
            <input
              type="text"
              id="email"
              name="email"
              onChange={handleChange}
              className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration duration-200 ease-in-out"
            />
          </div>
          <div className="relative mb-4">
            <label
              htmlFor="message"
              className="leading-7 tezt-sm text-gray-400"
            >
              Message
            </label>
            <textarea
              name="message"
              id="message"
              onChange={handleChange}
              className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 h-32 text-base outline-none text-gray-100 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
            />
          </div>
          <button
            type="submit"
            className="text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg"
          >
            Submit
          </button>
        </form>
      </div>
    </section>
  );
}

export default Contact;
